import { type IMinisterModel } from 'tno-core';

export const defaultMinister: IMinisterModel = {
  id: 0,
  name: '',
  description: '',
  aliases: '',
  position: '',
  isEnabled: true,
  sortOrder: 0,
};
